import { InputField } from '@components/forms/InputField'
import { NumberField } from '@components/forms/NumberField'

export function CoordinatorInformation() {
  return (
    <div>
      <h2 className='font-mitr text-[24px] ladding-[1.5] font-medium text-secondary dark:text-dark-10'>
        ข้อมูลฝ่ายผู้ประสานงาน
      </h2>
      <div className='grid grid-cols-3 tablet:grid-cols-2 mobile:grid-cols-1 gap-[20px] mt-[20px] mobile:mt-[10px]'>
        <InputField
          name='coordinatorFullName'
          label='ชื่อ - นามสกุลผู้ประสานงาน'
          placeholder='กรอกชื่อ - นามสกุลผู้ประสานงาน'
          showErrorMsg={false}
        />
        <InputField
          name='coordinatorEmail'
          label='อีเมล'
          placeholder='email@example.com'
          type='email'
          showErrorMsg={false}
        />
        <NumberField
          name='coordinatorPhoneNumber'
          label='เบอร์โทรศัพท์'
          placeholder='(+66) กรอกเบอร์โทรศัพท์'
          type='tel'
          maxLength={10}
          showErrorMsg={false}
        />
      </div>
    </div>
  )
}
